import React from "react";
import ReactDom from "react-dom";
import { ListGroup, ListGroupItem } from "reactstrap";
import { withRouter } from "react-router-dom";

class Menu extends React.Component {
  constructor(props) {
    super(props);
    this.clicMenu = this.clicMenu.bind(this);
    this.ocultaMenu = this.ocultaMenu.bind(this);
    this.buscaHijos = this.buscaHijos.bind(this);
    this.atrasPadres = this.atrasPadres.bind(this);
    this.generaHijos = this.generaHijos.bind(this);
    this.generaPadres = this.generaPadres.bind(this);
  }

  generaPadres() {
    if (this.props.datos !== null) {
      var padres = this.props.datos.filter((m) => m.vistaPadre === 0);
      return padres.map((r, index) => {
        return (
          <ListGroupItem
            tag="button"
            key={index}
            idmenu={r.idVista}
            onClick={(e) => this.buscaHijos(e)}
            action
          >
            {r.descripcionMenu}
          </ListGroupItem>
        );
      });
    }
  }

  buscaHijos(e) {
    var d = document.getElementById("dv_HijosMenu"),
      elm = e.target,
      idPadre = elm.getAttribute("idmenu"),
      hijos = this.props.datos.filter(
        (m) => m.vistaPadre === parseInt(idPadre, 10)
      ),
      dvPadre = document.getElementById("dv_PadresMenu");
    dvPadre.classList.remove("list_Show");
    dvPadre.classList.add("list_Hide");
    d.classList.remove("list_Hide");
    d.classList.add("list_Show");
    ReactDom.render(
      <ListGroup>
        {this.generaHijos(hijos)}
        <ListGroupItem
          tag="button"
          className="btn_fll_wht"
          onClick={(e) => this.atrasPadres(e)}
          action
        >
          <img src={require("../icons/arrowicon.png")} alt="" /> Atras
        </ListGroupItem>
      </ListGroup>,
      d
    );
  }

  atrasPadres() {
    var d = document.getElementById("dv_HijosMenu"),
      dvPadre = document.getElementById("dv_PadresMenu");
    ReactDom.unmountComponentAtNode(d);
    dvPadre.classList.remove("list_Hide");
    dvPadre.classList.add("list_Show");
    d.classList.remove("list_Show");
    d.classList.add("list_Hide");
  }

  generaHijos(datos) {
    if (this.props.datos !== null) {
      return datos.map((d, index) => {
        return (
          <ListGroupItem
            tag="button"
            key={index}
            idmenu={d.idVista}
            onClick={(e) => this.clicMenu(e)}
            action
          >
            {d.descripcionMenu}
          </ListGroupItem>
        );
      });
    }
  }

  ocultaMenu() {
    var c = document.getElementById("dv_contenido"),
      d = document.getElementById("div_menu"),
      m = document.getElementById("listaMenu");
    m.classList.add("Hide_All");
    d.classList.remove("dv_muestramenu");
    c.classList.remove("mnu_obscurece");
  }

  clicMenu(e) {
    const { history } = this.props;
    var elm = e.target,
      idM = elm.getAttribute("idmenu"),
      opcion = this.props.datos.filter((m) => m.idVista === parseInt(idM, 10));

    let url = opcion[0].url;
    this.ocultaMenu();
    if (url === "reporte") {
      history.push(
        `/${url}/${btoa(opcion[0].idVista)}/${btoa(opcion[0].descripcion)}`
      );
      window.location = `/${url}/${btoa(opcion[0].idVista)}/${btoa(opcion[0].descripcion)}`;
    } else {
      history.push(`/${url}`);
      window.location = `/${url}`;
    }
  }

  render() {
    return (
      <div className="dv_menu" id="div_menu">
        <div className="dv_mnu_Imageback">
          <img
            src={require("../icons/closeicon.png")}
            alt=""
            onClick={(e) => this.ocultaMenu(e)}
          />
        </div>
        <div className="dv_main Hide_All" id="listaMenu">
          <div id="dv_PadresMenu" className="list_Show">
            <ListGroup>{this.generaPadres()}</ListGroup>
          </div>
          <div id="dv_HijosMenu" />
        </div>
      </div>
    );
  }
}

export default withRouter(Menu);
